import client from '../client'

export async function triggerFullIntegrationVehicleIngestion({ vehicleId }) {
  return client(
    `${process.env.NEXT_PUBLIC_INTEGRATION_DOMAIN}/api/Integration/TriggerFullIntegrationVehicleIngestion`,
    {
      headers: { 'Content-Type': 'application/json ' },
      method: 'POST',
      body: JSON.stringify({ vehicleId }),
    },
  )
}
